import React, { useState, useEffect } from 'react';
import { CustomModal } from '../../../utils/components/CustomModal';

import Loader from '../../../assets/components/loader';

const CancelModal = ({
  changeModalState,
  handleInputChange,
  onSave,
  loading,
  cancelForm,
  questions,
  cancelStep
}) => {


  return(
    <CustomModal
      modalTitle={"Cancel My Subscription"}
      changeModalState={changeModalState}
      background="#EDF7FF"
      width={cancelStep === 1 ? "70vw" : ""}
      height={cancelStep === 1 ? "850px" : ""}
      onSave={onSave}
      loading={loading}
      footer={cancelStep === 1 ? true : false}
      submitButtonLabel={cancelStep === 1 ? "Cancel My Subscription":""}
      disableSubmitButton={false}
      cancelButton={false}
      centerFooter={true}
      >
      {cancelStep === 1 &&
        <div className="marquet--form--group">
          <div className="form--text">
            We are sorry to see you go! Please take a moment to tell us the reason you are leaving so we can continue to improve our services
          </div>
          {questions && questions.length > 0 && questions.map((it, i)=>(
            <div key={i}className="input--group no--border button-group">
              <h3 className="input--buttons--label">{it.question}</h3>
              {it.options && it.options.length > 0 && it.options.map((jt,j)=>(
                <div key={j} className="input--buttons--group">
                  <input
                    style = {{width:"20px", heigth:"20px"}}
                    name={`${i}-${j}`}
                    type={`${it.questionTypeName}`}
                    onChange={ev => handleInputChange(ev)}
                    checked={cancelForm[i].options[j].selected}
                  />
                  <label>{jt.option}</label>
                </div>
              ))}
              {it.questionTypeName === "Paragraph" &&
                <textarea
                  name={`${i}`}
                  onChange={ev => handleInputChange(ev)}
                  value={cancelForm[i].value}
                  rows={4}
                />
              }
            </div>
          ))}
        </div>
      }
      {cancelStep === 2 &&
        <div className="cancel--subscription--modal">
          <div className="text">
            <p>
              I acknowledge that  if I cancel my subscription I will permanently lose all the data of events held on the Marquet platform.
            </p>
          </div>
          <div className="button">
            <button onClick={ev => onSave(ev)} className="custom--button custom--button--marquet">
              Yes, cancel my subscription {loading && <Loader size="xs" />}
            </button>
          </div>
        </div>
      }
    </CustomModal>
  )
}

export default CancelModal;